import { Injectable } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { delay, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { RolesEnum } from "src/app/modules/constant";
// import * as moment from "moment";
@Injectable({
  providedIn: "root"
})
export class AuthService {
  //Only for demo purpose
  authenticated = false;
  url = environment.baseUrl;
  private superAdminRoles: string[] = [
    RolesEnum.DepartmentManager,
  ]
  logoutTimer: any;
  constructor(
    private store: LocalStoreService,
     private router: Router,
     private httpClient: HttpClient,
    ) {
    this.checkAuth();
  }

  checkAuth() {
    this.authenticated = this.store.getItem("uis_login_status");
  }

  getuser() {
    return of({});
  }

  signin(model:any) {
  
    return this.httpClient.post(`${this.url}api/TokenAuth/InfinitySignin`, model).pipe(map((response: any) => {

      let result = response['result'];
      Object.keys(result).forEach(key => {
        this.store.setItem(key, result[key]);
      });
      this.authenticated = true;
      this.store.setItem("uis_login_status", true);
      this.setSession(result['expireInSeconds']);
this.startTokenTimer();
      return response;
    }));
  }
  signout() {
    // this.currentUser = undefined
    let lang = localStorage.getItem('lang');
    localStorage.clear();
    this.authenticated = false;
    this.store.setItem("uis_login_status", false);
    localStorage.setItem('lang', lang!);
    this.store.setItem("demo_login_status", false);
    this.router.navigateByUrl("/sessions/signin");
  }
  private setSession(expiresIn: any) {
    // const expiresAt = moment().add(expiresIn, 'second');
    localStorage.setItem("expires_at", JSON.stringify(expiresIn.valueOf()));
  }
  getToken() {
    var token =this.store.getItem('accessToken')
    return token;
  }
  getuserId() {
    return this.store.getItem("userId")
  }


  decodeToken(token: string): any {
    const payload = token.split('.')[1]; // Get the payload part of the token
    const decoded = atob(payload); // Decode from base64
    return JSON.parse(decoded); // Parse JSON string into an object
}


isTokenExpired(): boolean {
    let token = this.getToken();
    if (!token) {
        return true; 
    }

    try {
        const decodedToken = this.decodeToken(token);
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        return decodedToken.exp < currentTime;
    } catch (error) {
        console.error('Error decoding token:', error);
        return true;
    }
}


getEncryptedToken() {
  return this.store.getItem('encryptedAccessToken');
}

// ✅ Call this right after successful login
  startTokenTimer() {
    const token = this.getToken();
    if (!token) return;
 
    const decoded: any = this.decodeToken(token);
    if (!decoded?.exp) return;
 
    const expireAt = decoded.exp * 1000; // convert to ms
    const currentTime = Date.now();
    const timeout = expireAt - currentTime;
 
    if (timeout > 0) {
      // store expiry for restore on refresh
      localStorage.setItem('token_expiry', expireAt.toString());
 
      // clear any old timer
      if (this.logoutTimer) clearTimeout(this.logoutTimer);
 
      // ✅ Schedule auto logout
      this.logoutTimer = setTimeout(() => {
        this.signout();
      }, timeout);
    }
  }
 
  // ✅ Restore timer on refresh or app reopen
  restoreTokenTimer() {
    const expireAt = localStorage.getItem('token_expiry');
    if (!expireAt) return;
 
    const timeout = +expireAt - Date.now();
    if (timeout > 0) {
      if (this.logoutTimer) clearTimeout(this.logoutTimer);
 
      this.logoutTimer = setTimeout(() => {
        this.signout();
      }, timeout);
    } else {
      this.signout();
    }
  }

}
